export default "### Start a new purchase\n\nThis will remove your current purchase\n";